import api from "../api";
import { getToken } from "../util/util";

/**
 * Search for ESCO skills based on query string
 * @param {string} query - The search query (minimum 2 characters)
 * @returns {Promise<{query: string, language: string, results: string[], total: number}>}
 */
export const searchEscoSkills = async (query, type, limit = 10) => {
  try {
    if (!query || query.length < 2) {
      return { query, language: "en", results: [], total: 0 };
    }

    const token = getToken();
    const response = await api.get(
      `/esco-skills/search?query=${encodeURIComponent(query)}&type=${type}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    console.error("Error searching ESCO skills:", error);
    
    // If unauthorized, return empty results
    if (error.response?.status === 401) {
      console.warn("Authentication required for ESCO skills search");
      return { query, language: "en", results: [], total: 0 };
    }
    
    // Return empty results on any error to prevent breaking the UI
    return { query, language: "en", results: [], total: 0 };
  }
};

/**
 * Get available languages for ESCO skills
 * @returns {Promise<string[]>}
 */
export const getAvailableLanguages = async () => {
  try {
    const response = await api.get("/esco-skills/languages");
    return response.data;
  } catch (error) {
    console.error("Error getting available languages:", error);
    return ["en", "es", "fr", "de", "it"]; // fallback
  }
};
